import { gql, useQuery } from '@apollo/client';
import { WithdrawInstrumentsQuery as Query } from './useInstruments.types';

const enabledInstrument = gql`
  fragment EnabledInstrument on ClearingWithdrawInstrument {
    instrumentId: id
    type
    minimum
    maximum
    currency
    fee {
      __typename
      ... on ClearingWithdrawFixedFee {
        amount {
          value
          currency {
            code
          }
        }
      }
      ... on ClearingWithdrawPercentFee {
        percent
      }
    }
  }
`;

const query = gql`
  query WithdrawInstrumentsQuery {
    clearing {
      withdrawInstrumentsV2(product: "UTCOM") {
        ...EnabledInstrument
      }
    }
  }
  ${enabledInstrument}
`;

export const useInstruments = () => {
  const { data, error, loading, refetch } = useQuery<Query>(query);
  return {
    loading,
    error,
    refetch: () => refetch(),
    instruments: data?.clearing?.withdrawInstrumentsV2 || [],
  };
};
